import { FC, useMemo } from 'react';
import SearchResults from '../../components/Search/SearchResults/index';
import Header from '../app/Header';
import i18n from '../../i18n';
import { HeaderDisplayType, HeaderInteractionType } from '../../interfaces';
import { Helmet } from 'react-helmet-async';
import StickyHeader from '../app/StickyHeader';
import Footer from '../../components/Footer';
import { useLocation } from 'react-router-dom';
import styles from './global-search.module.scss';
import { PageContextProvider } from '../ats-pages/page/page-context';
import { Layout } from '../../queries/ats/layout/types';

const Search: FC = () => {
  const { search } = useLocation();

  const query = useMemo(() => {
    const params = new URLSearchParams(search).get('q') || '';
    return params;
  }, [search]);

  return (
    <PageContextProvider
      page={{
        label: 'Search',
        slug: 'search',
        style: Layout.PageViewStyleType.GRID,
        sections: [],
        theme: {
          backgroundColor: '',
          backgroundImage: '',
          icon: '',
          name: '',
          primaryColor: '',
          secondaryColor: '',
        },
      }}
    >
      <div className={styles.container}>
        <Helmet>
          <title>{i18n.t<string>('search')}</title>
        </Helmet>
        <StickyHeader />
        <Header
          title={i18n.t('search')}
          displayType={HeaderDisplayType.Solid}
          interactionType={HeaderInteractionType.Full}
        />
        <SearchResults query={query} />
        <Footer />
      </div>
    </PageContextProvider>
  );
};

export default Search;
